import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import { useHistory } from "react-router-dom";
import { Form, Formik, Field } from "formik";
import { RenewalAppSchema } from "../../utils/validation";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button2 from "../../components/Button/Button2";
import Button3 from "../../components/Button/Button3";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import FormInput3 from "../../components/FormInput/FormInput3";
import jwt_decode from "jwt-decode";
import { PropTypes } from "prop-types";

const InputFormApp = (props) => {
  const { getStatus } = props;
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let name = user && user.name;

  let userToken = Storage.get("user-access-token");
  const token = jwt_decode(userToken);
  let userCompanyId = token && token.id;
  const applicationId = props.location.state && props.location.state.id;

  useEffect(
    () => {
      getStatus();
    },
    // eslint-disable-next-line
    [getStatus]
  );

  const goToApply = () => {
    history.go(-1);
  };

  const initialValues = {
    application_name: "",
    application_version: "",
  };

  const submitApplication = (value) => {
    const application = {
      company_id: userCompanyId,
      id: applicationId,
      application_name: value.application_name,
      application_version: value.application_version,
    };
    history.push({
      pathname: "/application/renewal",
      state: {
        application: application,
   
      },
    });
  };

  return (
    <div className="application">
      <Link to="/">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>

      <div className="application-start-form">
        <div className="form4"></div>
        <div className="application-start-form-header">
          <h1>Hello {name}</h1>
          <h3>
            Let's get you <br /> started
          </h3>
          <p>Provide the information of the POS Application Renewal</p>
        </div>

        <div className="application-wrap">
          <Formik
            initialValues={initialValues}
            validationSchema={RenewalAppSchema}
            onSubmit={submitApplication}
          >
            {({ values, isValid, dirty }) => {
              const disable1 =
                values.application_name === "" ||
                values.application_version === "";
              return (
                <Form id="form">
                  <div className="form-1">
                  <div className="app-input">
                      <Field
                        name="application_name"
                        label="Certified Device name"
                        placeholder="Enter certified Device name"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="application_version"
                        label="Specify Model of POS"
                        placeholder="Enter model of POS"
                        component={FormInput3}
                      />
                    </div>

                    <div className="application-wrap-buttons">
                      <Button2
                        width="45%"
                        height="45px"
                        word={"Back"}
                        onClick={goToApply}
                      />
                      <Button3
                        width="45%"
                        height="45px"
                        word={"Proceed"}
                        type={"submit"}
                        disabled={disable1}
                      />
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    appStatus: state.docs.status,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
});

InputFormApp.propTypes = {
  getStatus: PropTypes.func,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number
    })
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(InputFormApp);
